import { BaseDto } from './base.dto';

export class BookingStatusDto extends BaseDto {
    name?: string;
}
  